import React, { useState } from 'react';
import GoConsult from '../assets/portfolio/goconsult.jpg';
// import GoLearn from '../assets/portfolio/golearn.jpg';
// import HappyHive from '../assets/portfolio/happyhive.jpg';
import InnerPeace from '../assets/portfolio/innerPeace.jpg';
import Senait from '../assets/portfolio/senait.jpg';
// import Dowi from '../assets/portfolio/dowi.jpg';
import eflavours from '../assets/portfolio/eflavours.jpg';
import ourcompany from '../assets/portfolio/ourcomp.jpg';
// import teym from '../assets/portfolio/teym.jpg';
import weather from '../assets/portfolio/weather.jpg';
import yonas from '../assets/portfolio/yonas.jpg';
// import pdf from '../assets/portfolio/pdf generator.jpg';
import learnDev from '../assets/portfolio/learndev.jpg';
import allen from '../assets/portfolio/allen.png';
import marefiya from '../assets/portfolio/marefiya.jpg';
import qleardocs from '../assets/portfolio/qleardocs.jpg';
import qlearshot from '../assets/portfolio/qlearshot.jpg';
import room123 from '../assets/portfolio/room123.jpg';
import pocketlawyer from '../assets/portfolio/pocketlawyer.jpg';
import afroStride from '../assets/portfolio/afroStride.png';
import alrehan from '../assets/portfolio/al-rehan.png';
import stridePro from '../assets/portfolio/stridePro.png';
import strideWash from '../assets/portfolio/strideWash.png';
import smartEpic from '../assets/portfolio/smartEpic.png';
import zephyrSolution from '../assets/portfolio/zephyrSolution.png';
import zephyrCommunication from '../assets/portfolio/zephyrCommunication.png';

const INITIAL_COUNT = 9;

const Portfolio = () => {
  const [showAll, setShowAll] = useState(false);
  const portfolios = [
    {
      id: 19,
      src: learnDev,
      demo: 'https://learndevs.com/',
      code: '',
    },
    {
      id: 18,
      src: room123,
      demo: 'https://www.room123.ca/',
      code: '',
    },
    {
      id: 16,
      src: qleardocs,
      demo: 'https://www.qlearhomedocs.com/',
      code: '',
    },
    {
      id: 17,
      src: qlearshot,
      demo: 'https://www.qlearshot.com/',
      code: '',
    },
    {
      id: 15,
      src: marefiya,
      demo: 'https://marefiya-liard.vercel.app/',
      code: '',
    },
    // {
    //   id: 9,
    //   src: GoLearn,
    //   demo: 'https://www.gobeze.com/',
    //   code: '',
    // },
    {
      id: 25,
      src: smartEpic,
      demo: 'https://smart-epic.vercel.app/',
      code: '',
    },
    {
      id: 22,
      src: alrehan,
      demo: 'https://al-rehan.vercel.app/',
      code: '',
    },
    {
      id: 26,
      src: zephyrSolution,
      // demo: 'https://zephyrsolutions.ae/',
      demo: 'https://zephyr-solution.vercel.app/',
      code: '',
    },
    {
      id: 23,
      src: stridePro,
      // demo: 'https://www.strideproperties.ae/',
      demo: 'https://stride-properties.vercel.app/',
      code: '',
    },
    {
      id: 24,
      src: strideWash,
      demo: 'https://stride-auto-washing.vercel.app/',
      code: '',
    },
    {
      id: 27,
      src: zephyrCommunication,
      // demo: 'https://zephyrsolutions.ae/',
      demo: 'https://zephyr-communications.vercel.app/',
      code: '',
    },
    {
      id: 21,
      src: afroStride,
      demo: 'https://afro-stride-luxury-motor-2bcy.vercel.app/',
      code: '',
    },
    {
      id: 2,
      src: Senait,
      demo: 'https://www.senaittemesgen.com/',
      code: '',
    },
    {
      id: 20,
      src: pocketlawyer,
      demo: 'https://pocket-lawyer-livid.vercel.app/',
      code: '',
    },
    {
      id: 7,
      src: GoConsult,
      demo: 'https://gobeze-consult.vercel.app/',
      code: '',
    },
    {
      id: 14,
      src: allen,
      demo: 'https://allen-web.vercel.app/',
      code: '',
    },
    {
      id: 4,
      src: yonas,
      demo: 'https://yonas-designs.vercel.app/',
      code: '',
    },
    // {
    //   id: 5,
    //   src: Dowi,
    //   demo: 'https://dowi-consult.vercel.app/en',
    //   code: '',
    // },
    {
      id: 6,
      src: InnerPeace,
      demo: 'https://innerpeaceweb.netlify.app/',
      code: 'https://innerpeaceweb.netlify.app/',
    },
    {
      id: 11,
      src: ourcompany,
      demo: 'https://our-comp.vercel.app/',
      code: '',
    },
    {
      id: 12,
      src: eflavours,
      // demo: 'https://e-flavours.com/',
      demo: 'https://e-flavours-clone.vercel.app/',
      code: '',
    },
    // {
    //   id: 10,
    //   src: HappyHive,
    //   demo: 'https://challenge.happyhive.work/',
    //   code: 'https://challenge.happyhive.work/',
    // },
    // {
    //   id: 13,
    //   src: pdf,
    //   demo: 'https://ai-pdf-quiz-generator-cu2n.vercel.app/',
    //   code: '',
    // },
    {
      id: 3,
      src: weather,
      demo: 'https://weather-app-phi-gold-46.vercel.app/',
      code: '',
    },
    // {
    //   id: 1,
    //   src: teym,
    //   demo: 'https://teym.vercel.app/',
    //   code: '',
    // },
  ];

  const displayedPortfolios = showAll
    ? portfolios
    : portfolios.slice(0, INITIAL_COUNT);
  const hasMore = portfolios.length > INITIAL_COUNT;

  return (
    <div
      name='portfolio'
      className='bg-gradient-to-b from-black to-gray-800 w-full text-white'
    >
      {/* md:h-screen */}
      <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 border-gray-500'>
            Portfolio
          </p>
          <p className='py-6'>Check out some of my works right here</p>
        </div>

        <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-2'>
          {displayedPortfolios.map((port) => {
            return (
              <div
                key={port.id}
                className='shadow-md shadow-gray-600 rounded-lg overflow-hidden flex flex-col'
              >
                <div className='aspect-video w-full overflow-hidden bg-gray-700'>
                  <img
                    src={port.src}
                    alt=''
                    className='w-full h-full object-cover rounded-t-md duration-200 hover:scale-105'
                  />
                </div>
                <div className='flex items-center justify-center'>
                  <a
                    href={port.demo}
                    className='px-6 py-3 m-4 duration-200 hover:scale-105'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <button>Demo</button>
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        {hasMore && (
          <div className='flex justify-center mt-8'>
            <button
              onClick={() => setShowAll((prev) => !prev)}
              className='px-6 py-3 rounded-lg border-2 border-gray-500 text-white font-medium hover:bg-gray-700 hover:border-gray-400 transition-colors duration-200'
            >
              {showAll ? 'Show less' : 'Show more'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Portfolio;
